module.exports = "/images/vendor/flag-icon-css/flags/1x1/lc.svg?c056c2a721c5bd992bd4945d10f82541";